import { render } from "./pos-chat.vue?vue&type=template&id=3bb534ca"
import script from "./pos-chat.vue?vue&type=script&lang=js"
export * from "./pos-chat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__